// extracted by mini-css-extract-plugin
export default {"root":"classes_root__jPlvq","container":"classes_container__LlG2X","icon-container":"classes_icon-container__vmZA0","icon":"classes_icon__YyXfV","text":"classes_text__Oc6Y1"};